export default "__VITE_ASSET__Doze1QD5__"